import { styled } from '@openeducation/oe-it-themes';
import React, { useState } from 'react';
import { View } from 'react-native';
import { TextInput } from 'react-native-paper';

import { CenteredPanel } from '../../../atoms/centered-panel/centered-panel';
import { OEButton } from '../../../atoms/oe-button/oe-button';
import { OEText } from '../../../atoms/oe-text/oe-text';
import { flex, mb, mt, ph, pv } from '../../../style-utils';

export interface RecoverPasswordPageProps {
  backAction: () => void;
  onSubmit: (username: string) => void;
  usernameLabel?: string;
  buttonText?: string;
}

export const RecoverPasswordPage = ({
  backAction,
  onSubmit,
  usernameLabel = 'Username',
  buttonText = 'Send Password',
}: RecoverPasswordPageProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [recoverUsername, setRecoverUsername] = useState('');

  const handleOnPress = () => {
    setIsLoading(true);
    onSubmit(recoverUsername);
  };

  return (
    <CenteredPanel header="Recover your password" backAction={backAction}>
      <View style={[mt(48), flex('align-items-center')]}>
        <OEText fontSize={16} style={[flex('flex-1')]}>
          We’ve all been there. You will receive an email to reset the password.
        </OEText>
        <StyledTextInput
          label={usernameLabel}
          placeholder={usernameLabel}
          value={recoverUsername}
          mode="outlined"
          onChangeText={setRecoverUsername}
          autoComplete="off"
        />
        <OEButton
          loading={isLoading}
          disabled={isLoading || !recoverUsername}
          style={[mt(48), mb(0), pv(8), ph(23)]}
          onPress={handleOnPress}
        >
          {buttonText}
        </OEButton>
      </View>
    </CenteredPanel>
  );
};

const StyledTextInput = styled(TextInput)`
  margin-top: 48px;
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
`;

export default RecoverPasswordPageProps;
